import React, { FC } from 'react';
import EachTaskGroup from './EachTaskGroup';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import EachWOTask from './EachWOTask';

const GroupedTaskDisplay: FC<any> = ({
	groupedTasks,
	onEditTask,
	onDeleteTask,
	onAddNewTask = () => {},
	isAllowedToEdit,
	changeTitleForExistingTasks,
	timezonId,
	notCheckable,
	onGroupDelete,
	onShowAssociate,
	workOrder,
}): React.ReactElement => {
	return (
		<>
			{groupedTasks
				.filter((_) => !!_.groupTitle)
				.map((group, idx) => (
					<EachTaskGroup
						key={group.groupTitle}
						group={group}
						onTaskEdit={onEditTask}
						onTaskDelete={onDeleteTask}
						addNewTask={onAddNewTask}
						isAllowedToEdit={isAllowedToEdit}
						onEditGroupTitleComplete={changeTitleForExistingTasks}
						timezonId={timezonId}
						notCheckable={notCheckable}
						onGroupDelete={onGroupDelete}
						onShowAssociate={onShowAssociate}
						workOrder={workOrder}
					/>
				))}
			{nullSafeGetOrElse(
				'tasks',
				groupedTasks.find((_) => !_.groupTitle),
				[]
			).map((task, idx) => (
				<EachWOTask
					key={`task-item-ungrouped-${task.id || task.orderingId}`}
					task={task}
					onTaskEdit={onEditTask}
					onTaskDelete={onDeleteTask}
					onEnter={onAddNewTask('')}
					canEdit={isAllowedToEdit}
					timezonId={timezonId}
					notCheckable={notCheckable}
					onShowAssociate={onShowAssociate}
					workOrder={workOrder}
				/>
			))}
		</>
	);
};

export default GroupedTaskDisplay;
